import classNames from "classnames";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";

type LoyaltyTitleProps = {
  title: string;
  className?: string;
};

export const LoyaltyTitle = ({ title, className }: LoyaltyTitleProps) => {
  const t = useTranslate();
  return <h3 className={classNames("LoyaltyTitle", className)}>{t(title)}</h3>;
};
